import BubbleMenuToExtend from '@tiptap/extension-bubble-menu';

/**
 * @typedef {import('@tiptap/extension-bubble-menu').BubbleMenuOptions} BubbleMenuOptions
 * @typedef {import('@tiptap/core').Extension} Extension
 */

/**
 * @param {BubbleMenuOptions} options
 * @return {Extension<BubbleMenuOptions, any>}
 */
export const BubbleMenu = ({
   element = null,
   tippyOptions = {
       maxWidth: 'none',
       appendTo: () => document.body,
       onClickOutside: (instance) => {
           instance.hide();
       },
   },
} = {}) => {
    const {
        maxWidth = 'none',
        appendTo = () => document.body,
        onClickOutside = (instance) => {
            instance.hide();
        },
        ...restOptions
    } = tippyOptions;
    
    return BubbleMenuToExtend.configure({
        element,
        tippyOptions: {
            maxWidth,
            appendTo,
            onClickOutside,
            ...restOptions
        },
    });
};
